// extracted by css-extract-rspack-plugin
export default {"stepper":"stepper-10N_M","large":"large-3Y0oL","stepperUp":"stepperUp-2z26_","stepperDown":"stepperDown-1Ep2m","medium":"medium-1-V4Q","disabled":"disabled-2Mx9J"};